import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { Link } from "react-router-dom";
import { PageHeader, Card, Empty } from "@/components/ui-bits";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ChevronRight, Phone, MapPin } from "lucide-react";

const STATUS = ["Pending", "Out For Delivery", "Delivered", "Partially Delivered", "Cancelled", "Unable To Deliver"];
const STATUS_COLOR = {
  "Pending": "bg-slate-100 text-slate-700",
  "Out For Delivery": "bg-amber-50 text-amber-700",
  "Delivered": "bg-emerald-50 text-emerald-700",
  "Partially Delivered": "bg-cobalt-50 text-cobalt-700",
  "Cancelled": "bg-rose-50 text-rose-700",
  "Unable To Deliver": "bg-rose-50 text-rose-700",
};

export default function DriverDeliveries() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("");
  const [date, setDate] = useState("");

  function load() {
    const params = {};
    if (status) params.status = status;
    if (date) { params.frm = date; params.to = date; }
    api.get("/deliveries", { params }).then(r => setList(r.data));
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div data-testid="driver-deliveries-page">
      <PageHeader
        eyebrow="Driver App"
        title="My Deliveries"
        description="Your assigned drops. Tap a card to view details and update status."
      />
      <Card padding="p-4" className="mb-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
          <div>
            <Label className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-semibold">Status</Label>
            <Select value={status || "any"} onValueChange={(v)=>setStatus(v === "any" ? "" : v)}>
              <SelectTrigger className="mt-1"><SelectValue placeholder="Any"/></SelectTrigger>
              <SelectContent>
                <SelectItem value="any">Any</SelectItem>
                {STATUS.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-semibold">Date</Label>
            <Input type="date" value={date} onChange={e=>setDate(e.target.value)} className="mt-1"/>
          </div>
          <Button onClick={load} variant="outline">Filter</Button>
        </div>
      </Card>

      {list.length === 0 ? <Empty title="No assigned deliveries"/> : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3" data-testid="driver-deliveries-list">
          {list.map(d => (
            <Link to={`/driver/deliveries/${d.id}`} key={d.id}>
              <Card className="hover:shadow-md hover:-translate-y-0.5 transition-all cursor-pointer">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${STATUS_COLOR[d.status]}`}>{d.status}</span>
                      <span className="font-mono text-xs text-cobalt-600">{d.invoice_no}</span>
                      <span className="font-mono text-xs text-slate-400">{fmtDate(d.delivery_date)}</span>
                    </div>
                    <div className="font-heading text-lg font-semibold truncate">{d.customer_name}</div>
                    <div className="text-sm text-slate-500 mt-1 flex items-start gap-1.5"><MapPin size={13} className="mt-0.5 shrink-0"/><span className="truncate">{d.customer_address || "—"}</span></div>
                    {d.customer_mobile && (<div className="text-sm text-slate-500 mt-0.5 flex items-center gap-1.5"><Phone size={13}/><span className="font-mono">{d.customer_mobile}</span></div>)}
                    {d.route_name && <div className="text-[11px] uppercase tracking-[0.18em] text-cobalt-600 font-semibold mt-2">Route: {d.route_name}</div>}
                  </div>
                  <ChevronRight size={18} className="text-slate-400 shrink-0"/>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
